/**
 * Capira Features Page — assets/capira-features-page.js
 * Hero reveals, section IntersectionObserver, visual trigger.
 */
(function () {
  'use strict';

  const pref = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function observe(target, cb, threshold) {
    if (!target) return;
    if (pref) { cb(); return; }
    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) { cb(); io.disconnect(); }
    }, { threshold: threshold || 0.08 });
    io.observe(target);
  }

  /* ── 1. Hero reveals ───────────────────── */
  const hero     = document.querySelector('.capfp-hero');
  const heroEls  = document.querySelectorAll('[data-capfp-reveal]');

  if (hero) {
    observe(hero, () => {
      heroEls.forEach(el => {
        const d = parseInt(el.dataset.capfpDelay || '0', 10);
        setTimeout(() => el.classList.add('is-visible'), pref ? 0 : d);
      });
    }, 0.04);
  }

  /* ── 2. Feature section reveals ────────────── */
  document.querySelectorAll('[data-capfp-feat]').forEach(section => {
    const text   = section.querySelector('[data-capfp-text]');
    const visual = section.querySelector('[data-capfp-visual]');

    observe(section, () => {
      if (text)   setTimeout(() => text.classList.add('is-visible'),   pref ? 0 : 0);
      if (visual) setTimeout(() => visual.classList.add('is-visible'), pref ? 0 : 120);
    }, 0.06);
  });

  /* ── 3. Shopify design mode ────────────────── */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      heroEls.forEach(el => el.classList.add('is-visible'));
      document.querySelectorAll('[data-capfp-text], [data-capfp-visual]').forEach(el => {
        el.classList.add('is-visible');
      });
    });
  }

})();
